import { SITE } from "@/lib/useSeo";

const ORG = {
  "@type": "Organization",
  name: "ClariDent RCM",
  url: `${SITE}/`,
  logo: `${SITE}/logo.png`,
  email: "Billing@claridentrcm.com",
  sameAs: [
    "https://www.linkedin.com/company/claridentrcm",
    "https://www.instagram.com/claridentrcm",
    "https://www.facebook.com/claridentrcm",
    "https://x.com/claridentrcm",
  ],
};

export const organizationSchema = () => ({
  "@context": "https://schema.org",
  ...ORG,
  description:
    "Dental revenue cycle management — billing, claims, insurance verification, denial management, AR follow-up, and collections for dental practices, groups, and DSOs.",
});

export const webSiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "ClariDent RCM",
  url: `${SITE}/`,
});

export const serviceSchema = (svc) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: svc.title,
  serviceType: svc.title,
  description: svc.seo_description,
  url: `${SITE}/services/${svc.slug}`,
  provider: { "@type": "Organization", name: "ClariDent RCM", url: `${SITE}/` },
});

export const blogPostingSchema = (post) => ({
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  headline: post.title,
  description: post.seo_description || post.excerpt,
  image: `${SITE}${post.cover}`,
  datePublished: post.published_at,
  dateModified: post.published_at,
  author: { "@type": "Organization", name: "ClariDent RCM" },
  publisher: {
    "@type": "Organization",
    name: "ClariDent RCM",
    logo: { "@type": "ImageObject", url: `${SITE}/logo.png` },
  },
  mainEntityOfPage: { "@type": "WebPage", "@id": `${SITE}/resources/${post.slug}` },
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE}${it.path}`,
  })),
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
